/* eslint import/prefer-default-export: 0 */

import { EappEnum } from './eAppEnum';

export const CITIZEN = 'Citizen';
export const FOREIGN_BORN = 'ForeignBorn';
export const NATURALIZED = 'Naturalized';
export const DERIVED = 'Derived';
export const NOT_CITIZEN = 'NotCitizen';

export const citizenshipStatusOptions = [
  CITIZEN,
  FOREIGN_BORN,
  NATURALIZED,
  DERIVED,
  NOT_CITIZEN
];

export const PVQ_CITIZEN = 'U.S. Citizen';
export const PVQ_FOREIGN_BORN = 'U.S. Foreign';
export const PVQ_NATURALIZED = 'Naturalized';
export const PVQ_DERIVED = 'Derived';
export const PVQ_NOT_CITIZEN = 'Not U.S.';
export const PVQ_NATIONAL_BY_BIRTH_IN_US = 'National By Birth In U.S.';
export const PVQ_NATIONAL_BY_BIRTH_OUTSIDE_US = 'National By Birth Outside U.S.';

export const pvqCitizenshipStatusOptions = [
  PVQ_CITIZEN,
  PVQ_FOREIGN_BORN,
  PVQ_NATURALIZED,
  PVQ_DERIVED,
  PVQ_NOT_CITIZEN,
  PVQ_NATIONAL_BY_BIRTH_IN_US,
  PVQ_NATIONAL_BY_BIRTH_OUTSIDE_US
];

export const foreignBornDocumentTypes = ['FS-240', 'DS-1350', 'FS-545', 'N-560 or N-561', 'Other'];

export const notCitizenDocumentTypes = ['I-94', 'U.S. Visa', 'I-20', 'DS-2019', 'Form I-551 (Permanent Resident Card) or Form I-766 (Employment Authorization Card)', 'Other'];

// PVQ Dropdown values
export const PvqCitizenshipStatusOptions = new EappEnum([
  {
    i18nField: 'usCitizen', key: 'usCitizen', value: 'U.S. birth', text: 'A U.S. citizen by birth in the U.S. or a U.S. territory.'
  },
  {
    i18nField: 'usForeign', key: 'usForeign', value: 'U.S. Foreign', text: 'A U.S. citizen by birth, born to U.S. parent(s), in a foreign country.'
  },
  {
    i18nField: 'naturalized', key: 'naturalized', value: 'Naturalized', text: 'A naturalized U.S. citizen.'
  },
  {
    i18nField: 'derived', key: 'derived', value: 'Derived', text: 'A derived U.S. citizen.'
  },
  {
    i18nField: 'notUs', key: 'notUs', value: 'Not U.S.', text: 'Not a U.S. citizen.'
  },
]);

// PVQ Dropdown values
export const residencyValidationDocumentTypes = [
  'Form I-94 (Arrival/Departure Record)',
  'U.S. Visa Card (nonimmigrant visa)',
  'Form I-20 (Student Exchange Visitor Program (SEVP))',
  'Form DS-2019 ("J" Exchange Visitor Status)',
  'Other',
];

export function isNationalOrNonCitizen(status: string | null | undefined) {
  if (status === null || status === undefined) { return false; }
  return (
    status === PVQ_NOT_CITIZEN
    || status === PVQ_NATIONAL_BY_BIRTH_IN_US
    || status === PVQ_NATIONAL_BY_BIRTH_OUTSIDE_US
  );
}

export const isNotUSCLivesInUS = (status?: string, countryOfResidence?: string): boolean => {
  if (countryOfResidence === undefined) { return false; }

  const isUSResident = countryOfResidence === 'United States';

  const isNotCitizen = status === PVQ_NATIONAL_BY_BIRTH_IN_US || status === PVQ_NATIONAL_BY_BIRTH_OUTSIDE_US || status === PVQ_NOT_CITIZEN;
  const result = isNotCitizen && isUSResident;
  return result !== undefined ? result : false;
};

export const isNotUSCLivesOutsideUS = (status?: string, countryOfResidence?: string): boolean => {
  if (countryOfResidence === undefined) { return true; }

  const isNotUSResident = countryOfResidence !== 'United States';

  const isNotCitizen = status === PVQ_NATIONAL_BY_BIRTH_IN_US || status === PVQ_NATIONAL_BY_BIRTH_OUTSIDE_US || status === PVQ_NOT_CITIZEN;
  const result = isNotCitizen && isNotUSResident;
  return result !== undefined ? result : false;
};
